import React, { useState, useEffect, useRef } from 'react';
import Search from "../Assets/images/search.png";
import Chart from 'chart.js/auto';
import "../css/CustomerActivityReport.css";

function CustomerActivityReport() {
    const [selectedBot, setSelectedBot] = useState(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [botList, setBotList] = useState([
        { id: 1, name: "Customer Support Bot", active: true },
        { id: 2, name: "Sales Inquiry Bot", active: true },
        { id: 3, name: "Product FAQ Bot", active: false },
        { id: 4, name: "Order Tracking Bot", active: true },
        { id: 5, name: "Feedback Collection Bot", active: false }
    ]);
    const usageChartRef = useRef(null);
    const questionChartRef = useRef(null);
    const usageChartInstance = useRef(null);
    const questionChartInstance = useRef(null);


    const usageData = {
        1: {
            dailyUsage: [
                { name: 'Mon', users: 40 },
                { name: 'Tue', users: 30 },
                { name: 'Wed', users: 45 },
                { name: 'Thu', users: 55 },
                { name: 'Fri', users: 48 },
                { name: 'Sat', users: 25 },
                { name: 'Sun', users: 20 },
            ],
            topQuestions: [
                { question: "How do I reset my password?", count: 143 },
                { question: "Where is my order?", count: 98 },
                { question: "How do I return an item?", count: 76 },
                { question: "Is item X in stock?", count: 62 },
                { question: "What are your business hours?", count: 45 },
            ],
            metrics: {
                totalInteractions: 1245,
                avgResponseTime: "8 sec",
                satisfactionRate: "87%",
                handoffRate: "12%"
            }
        },
        2: {
            dailyUsage: [
                { name: 'Mon', users: 25 },
                { name: 'Tue', users: 32 },
                { name: 'Wed', users: 30 },
                { name: 'Thu', users: 35 },
                { name: 'Fri', users: 42 },
                { name: 'Sat', users: 28 },
                { name: 'Sun', users: 15 },
            ],
            topQuestions: [
                { question: "What are your pricing plans?", count: 120 },
                { question: "Do you offer discounts?", count: 95 },
                { question: "How to schedule a demo?", count: 80 },
                { question: "Compare premium vs basic", count: 65 },
                { question: "Enterprise solutions details", count: 40 },
            ],
            metrics: {
                totalInteractions: 950,
                avgResponseTime: "6 sec",
                satisfactionRate: "92%",
                handoffRate: "8%"
            }
        },
        3: {
            dailyUsage: [
                { name: 'Mon', users: 18 },
                { name: 'Tue', users: 22 },
                { name: 'Wed', users: 25 },
                { name: 'Thu', users: 30 },
                { name: 'Fri', users: 28 },
                { name: 'Sat', users: 20 },
                { name: 'Sun', users: 12 },
            ],
            topQuestions: [
                { question: "How to use feature X?", count: 110 },
                { question: "Troubleshooting guide", count: 85 },
                { question: "System requirements", count: 70 },
                { question: "Integration documentation", count: 55 },
                { question: "API reference", count: 40 },
            ],
            metrics: {
                totalInteractions: 820,
                avgResponseTime: "5 sec",
                satisfactionRate: "85%",
                handoffRate: "10%"
            }
        },
        4: {
            dailyUsage: [
                { name: 'Mon', users: 50 },
                { name: 'Tue', users: 45 },
                { name: 'Wed', users: 60 },
                { name: 'Thu', users: 70 },
                { name: 'Fri', users: 65 },
                { name: 'Sat', users: 40 },
                { name: 'Sun', users: 30 },
            ],
            topQuestions: [
                { question: "Where is my package?", count: 180 },
                { question: "Delivery timeframe", count: 140 },
                { question: "Change delivery address", count: 95 },
                { question: "Order cancellation", count: 80 },
                { question: "Shipping method change", count: 65 },
            ],
            metrics: {
                totalInteractions: 1480,
                avgResponseTime: "7 sec",
                satisfactionRate: "89%",
                handoffRate: "11%"
            }
        },
        5: {
            dailyUsage: [
                { name: 'Mon', users: 15 },
                { name: 'Tue', users: 20 },
                { name: 'Wed', users: 18 },
                { name: 'Thu', users: 22 },
                { name: 'Fri', users: 25 },
                { name: 'Sat', users: 15 },
                { name: 'Sun', users: 12 },
            ],
            topQuestions: [
                { question: "Rate your experience", count: 95 },
                { question: "Service improvement suggestions", count: 70 },
                { question: "Product feedback", count: 65 },
                { question: "Report a problem", count: 50 },
                { question: "Compliment a staff member", count: 35 },
            ],
            metrics: {
                totalInteractions: 670,
                avgResponseTime: "6 sec",
                satisfactionRate: "94%",
                handoffRate: "5%"
            }
        }
    };

    useEffect(() => {
        setSelectedBot(botList[0].id);
        const handleResize = () => {
            if (window.innerWidth > 768) {
                setIsSidebarOpen(true);
            } else {
                setIsSidebarOpen(false);
            }
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (!selectedBot || !usageChartRef.current || !questionChartRef.current) return;
        const createCharts = () => {
            if (usageChartInstance.current) {
                usageChartInstance.current.destroy();
            }

            const usageCtx = usageChartRef.current.getContext('2d');
            const botData = usageData[selectedBot];

            usageChartInstance.current = new Chart(usageCtx, {
                type: 'line',
                data: {
                    labels: botData.dailyUsage.map(day => day.name),
                    datasets: [{
                        label: 'Users',
                        data: botData.dailyUsage.map(day => day.users),
                        backgroundColor: 'rgba(63, 81, 181, 0.2)',
                        borderColor: 'rgba(63, 81, 181, 1)',
                        borderWidth: 2,
                        tension: 0.4,
                        pointRadius: 4,
                        pointBackgroundColor: 'rgba(63, 81, 181, 1)',
                        pointBorderColor: '#fff',
                        pointBorderWidth: 2,
                        pointHoverRadius: 6,
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        y: {
                            beginAtZero: true,
                            grid: {
                                color: 'rgba(0, 0, 0, 0.05)'
                            }
                        },
                        x: {
                            grid: {
                                display: false
                            }
                        }
                    },
                    plugins: {
                        legend: {
                            position: 'top',
                        },
                        tooltip: {
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                            titleColor: '#333',
                            bodyColor: '#666',
                            borderColor: 'rgba(63, 81, 181, 0.5)',
                            borderWidth: 1,
                            padding: 10,
                            displayColors: false,
                            callbacks: {
                                title: function (tooltipItems) {
                                    return tooltipItems[0].label;
                                },
                                label: function (context) {
                                    return `Users: ${context.parsed.y}`;
                                }
                            }
                        }
                    }
                }
            });
            if (questionChartInstance.current) {
                questionChartInstance.current.destroy();
            }

            const questionCtx = questionChartRef.current.getContext('2d');

            questionChartInstance.current = new Chart(questionCtx, {
                type: 'bar',
                data: {
                    labels: botData.topQuestions.map(q => q.question),
                    datasets: [{
                        label: 'Question Count',
                        data: botData.topQuestions.map(q => q.count),
                        backgroundColor: 'rgba(76, 175, 80, 0.7)',
                        borderColor: 'rgba(76, 175, 80, 1)',
                        borderWidth: 1,
                        borderRadius: 4,
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    indexAxis: 'y',  // Horizontal bar chart
                    scales: {
                        y: {
                            ticks: {
                                callback: function (value) {
                                    const label = this.getLabelForValue(value);
                                    // Adjust text truncation based on screen size
                                    const maxLength = window.innerWidth < 768 ? 15 : 25;
                                    return label.length > maxLength ? label.substring(0, maxLength) + '...' : label;
                                }
                            },
                            grid: {
                                display: false
                            }
                        },
                        x: {
                            beginAtZero: true,
                            grid: {
                                color: 'rgba(0, 0, 0, 0.05)'
                            }
                        }
                    },
                    plugins: {
                        legend: {
                            position: 'top',
                        },
                        tooltip: {
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                            titleColor: '#333',
                            bodyColor: '#666',
                            borderColor: 'rgba(76, 175, 80, 0.5)',
                            borderWidth: 1,
                            padding: 10,
                            displayColors: false,
                            callbacks: {
                                title: function (tooltipItems) {
                                    return botData.topQuestions[tooltipItems[0].dataIndex].question;
                                },
                                label: function (context) {
                                    return `Count: ${context.parsed.x}`;
                                }
                            }
                        }
                    }
                }
            });
        };

        // Create charts initially
        createCharts();

        // Update charts on window resize
        const handleResize = () => {
            createCharts();
        };

        window.addEventListener('resize', handleResize);

        // Cleanup on unmount
        return () => {
            window.removeEventListener('resize', handleResize);
            if (usageChartInstance.current) {
                usageChartInstance.current.destroy();
            }
            if (questionChartInstance.current) {
                questionChartInstance.current.destroy();
            }
        };
    }, [selectedBot, usageChartRef, questionChartRef]);

    const handleBotSelect = (botId) => {
        setSelectedBot(botId);
        if (window.innerWidth <= 768) {
            setIsSidebarOpen(false);
        }
    };

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    return (
        <>
            <h4 className="Head_title ReportDetails new_ReportDetails">
                <div className="DateRangeContain new_DateRangeContain">
                    <input placeholder='Enter Phone number' type='number' className='phone_input' />
                    <button
                        type="button"
                        className="SearchDateRange phone_number"
                    >
                        <img src={Search} alt="Search" />
                    </button>
                </div>
                <span> Customer Activity</span>
            </h4>
            {window.innerWidth <= 768 && (
                <button
                    className="customerActivity-mobileMenuBtn"
                    onClick={toggleSidebar}
                >
                    {isSidebarOpen ? 'Hide Bots' : 'Show Bots'}
                </button>
            )}
            <div className="customerActivity-container">
                <div className={`customerActivity-sidebar ${isSidebarOpen ? 'open' : ''}`}>
                    <h3 className="customerActivity-sidebarTitle">Bots Used</h3>
                    <ul className="customerActivity-botList">
                        {botList.map((bot, index) => (
                            <li
                                key={bot.id}
                                className={`customerActivity-botItem ${selectedBot === bot.id ? 'customerActivity-active' : ''} ${!bot.active ? 'customerActivity-inactive' : ''}`}
                                onClick={() => bot.active && handleBotSelect(bot.id)}
                            >
                                <span className="customerActivity-botNumber">{index + 1}</span>
                                <span className="customerActivity-botName">{bot.name}</span>
                                {!bot.active && <span className="customerActivity-inactiveLabel">Inactive</span>}
                            </li>
                        ))}
                    </ul>
                </div>
                {selectedBot && (
                    <div className="customerActivity-content">
                        <h2 className="customerActivity-botTitle">
                            {botList.find(bot => bot.id === selectedBot)?.name} - Activity Dashboard
                        </h2>
                        <div className="customerActivity-metricsContainer">
                            <div className="customerActivity-metricCard">
                                <h4>Total Interactions</h4>
                                <p className="customerActivity-metricValue">{usageData[selectedBot].metrics.totalInteractions}</p>
                            </div>
                            <div className="customerActivity-metricCard">
                                <h4>Total Message</h4>
                                <p className="customerActivity-metricValue">{usageData[selectedBot].metrics.avgResponseTime}</p>
                            </div>
                            <div className="customerActivity-metricCard">
                                <h4>Total Received</h4>
                                <p className="customerActivity-metricValue">{usageData[selectedBot].metrics.satisfactionRate}</p>
                            </div>
                        </div>
                        <div className="customerActivity-tableSection">
                            <h3 className="customerActivity-tableTitle">Most Frequently Asked Questions</h3>
                            <div className="customerActivity-tableContainer">
                                <table className="customerActivity-table">
                                    <thead>
                                        <tr>
                                            <th>Question</th>
                                            <th>Count</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {usageData[selectedBot].topQuestions.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.question}</td>
                                                <td>{item.count}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="customerActivity-chartContainer">
                            <h3 className="customerActivity-chartTitle">Daily Usage</h3>
                            <div className="customerActivity-chart">
                                <canvas ref={usageChartRef}></canvas>
                            </div>
                        </div>
                        <div className="customerActivity-chartContainer">
                            <h3 className="customerActivity-chartTitle">Question Distribution</h3>
                            <div className="customerActivity-chart">
                                <canvas ref={questionChartRef}></canvas>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}

export default CustomerActivityReport;